import React from "react";
import Footer from "page/Home/Footer2";
import { connect } from "react-redux";
import IconElement from "component/IconElement/index";
import AlertDialog from "./FormElements/Dialog/index";
import { Redirect } from "react-router-dom";
import FormTemplate from "./FormElements/index";
import { useStyles } from "./style";
import mapStateToProps from "./mapStateToProps";
import mapDispatchToProps from "./mapDispatchToProps";

const Login = (props) => {
  const classes = useStyles(props);

  if (props.authenticated)
    return (
      <Redirect
        to={{
          pathname: "/",
          state: { from: props.location, authenticated: props.authenticated },
        }}
      />
    );
  else
    return (
      <>
        <div className={classes.loginContainer}>
          <div className={classes.title}>PORTAL WEB TSE</div>
          <div className={classes.loginBox}>
            <div className={classes.img}>
              <IconElement />
            </div>
            <h1 className={classes.titleLeft}> Bienvenido! </h1>
            <FormTemplate />
          </div>
          <AlertDialog />
        </div>
        <div>
          <Footer className={classes.footer} />
        </div>
      </>
    );
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
